module.exports = __webpack_public_path__ + "static/media/tissues.0b55a1c3.svg";